// removed by extract-text-webpack-plugin
module.exports = {"container":"SubmissionPanelMenu__container___3MgdP","header":"SubmissionPanelMenu__header___244cF"};


//////////////////
// WEBPACK FOOTER
// ./src/submission/components/SubmissionPanelMenu.css
// module id = 769
// module chunks = 0